import React from "react";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-[2px] p-4"
      style={{ marginTop: "0" }}
    >
      <div className="bg-section-card-bg rounded-2xl w-full max-w-lg p-6 shadow-2xl relative overflow-y-auto max-h-[85vh] border border-section-border">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-section-muted hover:text-section-text transition-colors"
          aria-label="Close modal"
        >
          ✕
        </button>
        {title && (
          <h2 className="text-xl font-bold text-section-text mb-4 pr-8">{title}</h2>
        )}
        <div className="space-y-4 text-section-muted">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
